import React, { memo } from "react";
import GridColumn from "../../components/grid/GridColumn";

interface GridHeaderCellProps<T> {
    index: number;
    column: GridColumn<T>;
    sortField: string;
    blockSort?: boolean;
    onClick?: (column: GridColumn<T>) => void;
}

interface GridHeaderCellState {
    cellRef: React.RefObject<HTMLTableCellElement>;
}

class GridHeaderCell<T> extends React.Component<
    GridHeaderCellProps<T>,
    GridHeaderCellState
> {
    getSortIndicator(column: GridColumn<T>): JSX.Element | null {
        if (!this.props.sortField) return null;

        switch (this.props.sortField) {
            case column.field:
                return <i className="inline-text">keyboard_arrow_up</i>;
            case `-${column.field}`:
                return <i className="inline-text">keyboard_arrow_down</i>;
            default:
                return null;
        }
    }
    tooltip(column: GridColumn<T>) {
        return column.headTooltip ? column.headTooltip : null;
    }

    render(): React.ReactNode {
        let classes = "";
        let tooltip: string | null = "";

        if (this.props.index === 0 && !this.props.blockSort) {
            classes += " tooltip-indicator";
            tooltip = "Temporarily sort columns by clicking a column header";
        } else {
            tooltip = this.tooltip(this.props.column);
        }

        return (
            <th
                className={classes}
                style={{ width: this.props.column.width }}
                onClick={() =>
                    !this.props.blockSort &&
                    this.props?.onClick?.(this.props.column)
                }
                data-tip={tooltip}
                data-place="right">
                {this.props.column.header}
                {this.getSortIndicator(this.props.column)}
            </th>
        );
    }
}

export default memo(GridHeaderCell);
